<template>
  <div class="page-fixed">
    <vue-waterfall-easy
      :imgsArr="imgsArr"
      @scrollReachBottom="getData"
      :mobileGap="14"
      :maxCols="2"
    >
      <section class="bottom">
        <h3>
          <img
            src="@/assets/img-m/icon-new.png"
          />大会开始的三季度为IE放开你的看法金额大会上看到楼hdskdskdhsdhskhdk
        </h3>
        <p>
          2010-10-10 12:10
        </p>
      </section>
    </vue-waterfall-easy>
  </div>
</template>

<script>
import vueWaterfallEasy from 'vue-waterfall-easy'
import axios from 'axios'
export default {
  name: 'app',
  components: {
    vueWaterfallEasy
  },
  data() {
    return {
      imgsArr: [],
      group: 1
    }
  },
  methods: {
    getData() {
      axios
        .get(
          'https://lfyfly.github.io/vue-waterfall-easy/demo/static/mock/data.json?group=' +
            this.group
        ) // 真实环境中，后端会根据参数group返回新的图片数组，这里我用一个惊呆json文件模拟
        .then(res => {
          res.data.forEach((elm, index) => {
            ;(elm.src = `https://lfyfly.github.io/vue-waterfall-easy/demo/static/img/${index++}.jpg`),
              (elm.href = '/mobile/video/detail?id=')
          })
          this.imgsArr = this.imgsArr.concat(res.data)
          this.group++
        })
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.page-fixed {
  background: $mainBackground;
}
/deep/.vue-waterfall-easy-container {
  width: 7rem;
  margin: 0 auto;
  /deep/.default-card-animation {
    border-radius: 0.1rem;
    overflow: hidden;
  }
}
.bottom {
  padding: 0.2rem;
  background: #fff;
  h3 {
    font-size: 0.24rem;
    line-height: 0.4rem;
    color: #666;
    @include ellipsisMultiline($number: 2);
    img {
      width: 0.7rem;
      margin-right: 0.1rem;
      vertical-align: middle;
    }
  }
  p {
    font-size: 0.24rem;
    color: #999;
    padding-top: 0.1rem;
  }
}
</style>
